import { Badge } from '@/components/ui/badge';
import type { BillableItemCategory } from './CategorySelect';

interface CategoryBadgeProps {
  category: BillableItemCategory;
  className?: string;
}

const categoryConfig: Record<BillableItemCategory, { label: string; variant: 'default' | 'secondary' | 'outline' | 'destructive' }> = {
  professional_fee: {
    label: 'Professional Fee',
    variant: 'default', // Blue
  },
  add_service: {
    label: 'Add Service',
    variant: 'secondary', // Purple
  },
  billable_expense: {
    label: 'Billable Expense',
    variant: 'outline', // Gray
  },
  pass_through: {
    label: 'Pass-Through',
    variant: 'destructive', // Orange (using destructive as placeholder for orange)
  },
};

export function CategoryBadge({ category, className }: CategoryBadgeProps) {
  const config = categoryConfig[category];

  if (!config) {
    return null;
  }

  return (
    <Badge variant={config.variant} className={className}>
      {config.label}
    </Badge>
  );
}
